import { ApiOperationBase } from 'api/rtk-api'

import { MetaInformation, Processed, Submitted } from './event-information'

export interface ExternalTransferProps {
  date: string
  operation: ApiOperationBase
}

export const ExternalTransfer = ({ date, operation }: ExternalTransferProps) => (
  <MetaInformation>
    <Submitted date={date} />
    <Processed date={date} operationState={operation.state} />
  </MetaInformation>
)
